// 入职进度页api

import axios from '../utils/fetch';

export const getBaseInfo = (options) => {
  const url = "/api/zmbiz-teacher-h5-api/teacher/process/getBaseInfo";
  return axios.postSign(url, options);
};

export const getInteviewInfo = (options) => {
  const url = "/api/zmbiz-teacher-h5-api/teacher/process/getInteviewInfo";
  return axios.postSign(url, options);
};

export const getTrainInfo = (options) => {
  const url = "/api/zmbiz-teacher-h5-api/teacher/process/getTrainInfo";
  return axios.postSign(url, options);
};

export const getEntryInfo = (options) => {
  const url = "/api/zmbiz-teacher-h5-api/teacher/process/getEntryInfo";
  return axios.postSign(url, options);
};

export const getRecycleInfo = (options) => {
  const url = "/api/zmbiz-teacher-h5-api/teacher/process/getRecycleInfo";
  return axios.postSign(url, options);
};

export const getTeaPeriodStateByTeaId = (options) => {
  const url = "/api/zmbiz-teacher-h5-api/teacher/process/getTeaPeriodStateByTeaId";
  return axios.postSign(url, options);
};

export const getStaticPdfUrl = (options) => {
  // return Promise.resolve('https://mobile-global-front.zmaxis.com/a.pdf');
  const url = "/api/zmbiz-teacher-h5-api/teacher/process/getStaticPdfUrl";
  return axios.postSign(url, options);
};

export const getConnectWechat = (options) => {
  const url = "/api/zmbiz-teacher-h5-api/teacher/process/getConnectWechat";
  return axios.getSign(url, options);
};

export const getTrainDingDingrcode=(options)=>{
  const url = "/api/zmbiz-teacher-h5-api/teacher/process/getTrainJoinInfo";
  return axios.postSign(url,options);
}